import clsx from 'clsx';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    MyTableCell1,
} from "../../../../styling/Styles";
import { convertQualityScoreToLetter, colorizeRank } from '../../../QualityPage/QualityTabs';

//  This component renders the cell of the row that is responsible for project quality
const ProjectQualityCell = ({label, index, showStatus,reason, projectName}) => {

    const navigate = useNavigate();

    const navigateTo = () => {

        if(reason === 'front'){
            navigate("/front_project_quality", { state: { reason: "front",  projectName } });
        }
        else if (reason === 'server'){
            navigate('/server_project_quality', { state: { reason: 'server', projectName } });
        }
    }

    return(
        <MyTableCell1
            align="center"
            style={
                index % 2 === 0
                ? null
                : { backgroundColor: "#CFD8E0" }
            }
            onClick={convertQualityScoreToLetter(label) !== '-' ? () => navigateTo() : null}
            className={convertQualityScoreToLetter(label) !== '-' ? clsx('teamSelector') : null}
            >
                <span style={showStatus === false ? {color: '#999999'}: {color: colorizeRank(label)}}>{convertQualityScoreToLetter(label)}</span>   
        </MyTableCell1>
    )
}


export default ProjectQualityCell;